export default "__VITE_ASSET__DInYCDgV__"